export default "__VITE_ASSET__n6$TKqRm__"